



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import OrderIssue from "./OrderIssue";
// import CreateGRN from "./CreateGRN";
// import InvoiceForm from "./RestaurantInvoiceForm";

// import { useNavigate } from "react-router-dom";
// /* ✅ IMPORT REVIEW MODAL */
// import ReviewModal from "./ReviewModal";
// import { useTranslation } from "react-i18next";

// const OrderDetails = ({ orderId, onBack, onTrack }) => {
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [showReviewModal, setShowReviewModal] = useState(false);
//   const { t, i18n } = useTranslation();

//   const formatCurrency = (value) => {
//   return new Intl.NumberFormat(
//     i18n.language === "ar" ? "ar-QA" : "en-US",
//     {
//       style: "currency",
//       currency: "QAR",
//     }
//   ).format(value);
// };

// const formatOrderId = (id) => {
//   if (i18n.language !== "ar") return id;

//   return id.replace(/\d/g, (d) =>
//     new Intl.NumberFormat("ar-QA").format(d)
//   );
// };


//   const formatDateTime = (date) => {
//   if (!date) return "-";

//   const d = new Date(date);

//   return d.toLocaleString(
//     i18n.language === "ar" ? "ar-QA" : "en-US",
//     {
//       year: "numeric",
//       month: "numeric",
//       day: "numeric",
//       hour: "numeric",
//       minute: "2-digit",
//       second: "2-digit",
//     }
//   );
// };

//   useEffect(() => {
//     if (!orderId) return;

//     setLoading(true);
//     axios
//       .get(
//         `https://api.mahal.qa/api/v1/orders/restaurant/orders/${orderId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(res => setData(res.data))
//       .catch(() => setError("Failed to load order details"))
//       .finally(() => setLoading(false));
//   }, [orderId, token]);

//   if (!orderId) return null;
//   if (loading) return <p>Loading order details…</p>;
//   if (error) return <p className="err">{error}</p>;
//   if (!data) return null;

//   /* ✅ IMPORTANT */
//   const { header, items, recurring, timeline = [], delivery } = data;

//   /* ================= OPEN SCREENS ================= */
//   // if (showGRN) return <CreateGRN orderId={orderId} onBack={() => setShowGRN(false)} />;
//   // if (showInvoice) return <InvoiceForm orderId={orderId} onBack={() => setShowInvoice(false)}/>;

//   // if (issueOrderId) {
//   //   return (
//   //     <OrderIssue
//   //       orderId={issueOrderId}
//   //       orderItems={items}
//   //       onBack={() => setIssueOrderId(null)}
//   //     />
//   //   );
//   // }

// const statusLabel = (s) => {
//   if (s === "OUT_FOR_DELIVERY") return t("resout_for_delivery");
//   if (s === "ACCEPTED") return t("resconfirmed");
//   if (s === "DELIVERED") return t("resdelivered");
//   if (s === "REJECTED") return t("rescancelled");
//   return t("resplaced");
// };

//   const statusClass = (s) => {
//     if (s === "DELIVERED") return "success";
//     if (s === "OUT_FOR_DELIVERY") return "warning";
//     if (s === "REJECTED") return "danger";
//     return "info";
//   };

//   return (
//     <div className="dashboard_page">

//       {/* HEADER */}
//       <div className="page_header">
//       <h2>{t("resorder_details")}</h2>

//       <button className="btn_add_item_v2" onClick={onBack}>
//         <i className="fa fa-arrow-left me-2"></i>{t("resback")}
//       </button>
//       </div>

//       {/* ORDER SUMMARY */}
//       <div className="card order_summary">
//         <div className="summary_left">
//           <p>
//             <b>{t("resorder_id")}:</b>{" "}
//             <span dir="ltr" style={{ unicodeBidi: "isolate" }}>
//               {formatOrderId(header.order_id)}
//             </span>
//           </p>
//           <p><b>{t("resorder_date")}:</b>{" "}{formatDateTime(header.order_date)}</p>
//           <p><b>{t("ressupplier")}:</b> {i18n.language === "ar"
//             ? header.company_name_arabic || header.company_name_english
//             : header.company_name_english}</p>
//           <span className={`status_badge ${statusClass(header.status)}`}>
//             {statusLabel(header.status)}
//           </span>
//         </div>

//         <div className="summary_right">
//           <span>{t("restotal_amount")}</span>
//           <h3>{formatCurrency(header.total_amount)}</h3>
//         </div>
//       </div>

//       {/* INFO GRID */}
//       <div className="row mt-4">

//       {/* RESTAURANT DETAILS */}
//       <div className="col-md-6">
//         <div className="card">
//           <h5 className="card_title">{t("resrestaurant_details")}</h5>

//           <p>
//             <b>{t("resname")}:</b>{" "}
//             {i18n.language === "ar"
//               ? header.restaurant_name_arabic || header.restaurant_name_english
//               : header.restaurant_name_english}
//           </p>
//           <p><b>{t("rescontact")}:</b> {header.restaurant_contact_name}</p>
//           <p><b>{t("resmobile")}:</b> {header.restaurant_contact_mobile}</p>
//           <p><b>{t("resemail")}:</b> {header.restaurant_contact_email}</p>

//           <p className="mt-2">
//             <b>{t("resaddress")}:</b><br />
//             {header.restaurant_street}, {header.restaurant_building}<br />
//             {t("resshop_no")}: {header.restaurant_shop_no}<br />
//             {t("reszone")}: {header.restaurant_zone}<br />
//             {header.restaurant_city}, {header.restaurant_country}
//           </p>
//         </div>
//       </div>


//       {/* SUPPLIER DETAILS */}
//       <div className="col-md-6">
//         <div className="card">
//           <h5 className="card_title">{t("ressupplier_details")}</h5>

//           <p>
//             <b>{t("resname")}:</b>{" "}
//             {i18n.language === "ar"
//               ? header.company_name_arabic || header.company_name_english
//               : header.company_name_english}
//           </p>
//           <p><b>{t("rescontact")}:</b> {header.supplier_contact}</p>
//           <p><b>{t("resmobile")}:</b> {header.supplier_mobile}</p>
//           <p><b>{t("resemail")}:</b> {header.supplier_email}</p>

//           <p className="mt-2">
//             <b>{t("resaddress")}:</b><br />
//             {header.supplier_address || header.supplier_street}<br />
//             {t("reszone")}: {header.supplier_zone}<br />
//             {header.supplier_country}
//           </p>
//         </div>
//       </div>
//       </div>


//       {/* DELIVERY DETAILS */}
//       {delivery && header.status === "OUT_FOR_DELIVERY" && (
//         <div className="card mt-4">
//             <h5 className="card_title">🚚 {t("resdelivery_details")}</h5>

//             <p><b>{t("resdelivery_type")}:</b> {delivery.delivery_type}</p>

//           {delivery.delivery_type === "OWN" && (
//             <>
//               <p><b>{t("resdriver")}:</b> {delivery.driver_name}</p>
//               <p><b>{t("resdriver_mobile")}:</b> {delivery.driver_mobile}</p>

//               <p><b>{t("resvehicle_type")}:</b> {delivery.vehicle_type || "-"}</p>
//               <p><b>{t("resvehicle_number")}:</b> {delivery.vehicle_number || "-"}</p>
//             </>
//           )}

//           {delivery.delivery_type === "PARTNER" && (
//             <>
//               <p><b>{t("respartner")}:</b> {delivery.partner_name}</p>
//             </>
//           )}

//             <p>
//               <b>{t("resestimated_arrival")}:</b>{" "}
//               {delivery.estimated_delivery_time
//                 ? formatDateTime(delivery.estimated_delivery_time)
//                 : "-"}
//             </p>
//         </div>
//       )}


//       {delivery && header.status === "DELIVERED" && (
//         <div className="card mt-4 border-success">
//           <h5 className="card_title">✅ {t("resdelivery_completed")}</h5>

//           {/* <p>
//             <b>Delivered To:</b>{" "}
//             {delivery.received_by || "Not specified"}
//           </p>

//           <p>
//             <b>Delivered At:</b>{" "}
//             {delivery.delivered_at
//               ? new Date(delivery.delivered_at).toLocaleString()
//               : "-"}
//           </p> */}

//           <hr />

//             <p><b>{t("resdriver")}:</b> {delivery.driver_name}</p>
//             <p><b>{t("resdriver_mobile")}:</b> {delivery.driver_mobile}</p>

//             <p>
//               <b>{t("resvehicle")}:</b>{" "}
//               {delivery.vehicle_type || "-"} {delivery.vehicle_number || ""}
//             </p>
//         </div>
//       )}
      

//       {recurring && (
//         <div className="card mt-3">
//           <h5 className="card_title">{t("resrecurring_schedule")}</h5>

//           <p><b>{t("resfrequency")}:</b> {recurring.frequency}</p>

//           {recurring.weekdays?.length > 0 && (
//             <p><b>{t("resdays")}:</b> {recurring.weekdays.join(", ")}</p>
//           )}

//           <p><b>{t("resstart_date")}:</b> {formatDateTime(recurring.start_date)}</p>

//           {recurring.end_date && (
//             <p><b>{t("resend_date")}:</b> {formatDateTime(recurring.end_date)}</p>
//           )}

//           <p><b>{t("resnext_run")}:</b> {formatDateTime(recurring.next_run_date)}</p>

//           <p><b>{t("resstatus")}:</b> {recurring.status}</p>
//         </div>
//       )}

    

//       {/* ITEMS */}
//       <div className="card mt-4">
//         <h5 className="card_title">{t("resorder_items")}</h5>
//         <table className="table order_table">
//           <thead>
//             <tr>
//               <th>{t("resitem")}</th>
//               <th>{t("resqty")}</th>
//               <th className="text-end">{t("resprice")}</th>
//             </tr>
//           </thead>
//           <tbody>
//             {items.map((i, idx) => (
//               <tr key={idx}>
//                 <td>
//                   {i18n.language === "ar"
//                     ? i.product_name_arabic || i.product_name_english
//                     : i.product_name_english}
//                 </td>
//                 <td>{i.quantity}</td>
//                 <td className="text-end" dir="ltr">
//                   {formatCurrency(i.total_amount)}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>


//        {/* ✅ REVIEW MODAL POPUP */}
//       {showReviewModal && (
//         <ReviewModal
//           order={{
//             order_id: header.order_id,
//             supplier_name: header.supplier_name,
//             total_amount: header.total_amount,
//           }}
//           onClose={() => setShowReviewModal(false)}
//         />
//       )}

//       {/* ACTION BAR */}
//       <div className="cta_bar">
//         {header.status !== "DELIVERED" &&     
//         header.status !== "REJECTED" &&
//         header.status !== "CANCELLED" &&(
//           <button
//             className="btn btn-primary btn-lg"
//             onClick={() => onTrack(orderId)}
//           >
//             <i className="fa fa-location-arrow me-2"></i>
//             {t("restrack_order")}
//           </button>
//         )}

//         {header.status === "DELIVERED" && (
//           <>
//                 {/* ✅ REVIEW BUTTON */}
//             <button
//               className="btn btn-outline-success btn-lg"
//               onClick={() => setShowReviewModal(true)}
//             >
//               {t("ressubmit_review")}
//             </button>
//             <button
//               className="btn btn-outline-danger btn-lg"
//               onClick={() =>
//                 navigate(`/restaurantdashboard/issues/${header.order_id}`)
//               }
//             >
//               {t("resreport_issue")}
//             </button>

//             <button
//               className="btn btn-outline-secondary btn-lg"
//               onClick={() =>
//                 navigate("/restaurantdashboard/invoices", {
//                   state: { orderId: header.order_id }
//                 })
//               }
//             >
//               {t("resview_invoice")}
//             </button>


//             <button
//               className="btn btn-outline-primary btn-lg"
//               onClick={() =>
//                 navigate(`/restaurantdashboard/grn/${header.order_id}`)
//               }
//             >
//               {t("rescreate_grn")}
//             </button>

//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrderDetails;






import React, { useEffect, useState } from "react";
import axios from "axios";
import OrderIssue from "./OrderIssue";
import CreateGRN from "./CreateGRN";
import InvoiceForm from "./RestaurantInvoiceForm";

import { useNavigate } from "react-router-dom";
/* ✅ IMPORT REVIEW MODAL */
import ReviewModal from "./ReviewModal";
import { useTranslation } from "react-i18next";

const OrderDetails = ({ orderId, onBack, onTrack }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const { t, i18n } = useTranslation();

  const formatCurrency = (value) => {
    return new Intl.NumberFormat(
      i18n.language === "ar" ? "ar-QA" : "en-US",
      {
        style: "currency",
        currency: "QAR",
      }
    ).format(value);
  };

  const formatOrderId = (id) => {
    if (i18n.language !== "ar") return id;

    return id.replace(/\d/g, (d) =>
      new Intl.NumberFormat("ar-QA").format(d)
    );
  };


  const formatDateTime = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    return d.toLocaleString(
      i18n.language === "ar" ? "ar-QA" : "en-US",
      {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
      }
    );
  };

  useEffect(() => {
    if (!orderId) return;

    setLoading(true);
    axios
      .get(
        `https://api.mahal.qa/api/v1/orders/restaurant/orders/${orderId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => setData(res.data))
      .catch(() => setError("Failed to load order details"))
      .finally(() => setLoading(false));
  }, [orderId, token]);

  if (!orderId) return null;
  if (loading) return <p>Loading order details…</p>;
  if (error) return <p className="err">{error}</p>;
  if (!data) return null;

  /* ✅ IMPORTANT */
  const { header, items, recurring, timeline = [], delivery } = data;

  /* ================= OPEN SCREENS ================= */
  // if (showGRN) return <CreateGRN orderId={orderId} onBack={() => setShowGRN(false)} />;
  // if (showInvoice) return <InvoiceForm orderId={orderId} onBack={() => setShowInvoice(false)}/>;

  // if (issueOrderId) {
  //   return (
  //     <OrderIssue
  //       orderId={issueOrderId}
  //       orderItems={items}
  //       onBack={() => setIssueOrderId(null)}
  //     />
  //   );
  // }

  const statusLabel = (s) => {
    if (s === "OUT_FOR_DELIVERY") return t("resout_for_delivery");
    if (s === "ACCEPTED") return t("resconfirmed");
    if (s === "DELIVERED") return t("resdelivered");
    if (s === "REJECTED") return t("rescancelled");
    return t("resplaced");
  };

  const statusClass = (s) => {
    if (s === "DELIVERED") return "success";
    if (s === "OUT_FOR_DELIVERY") return "warning";
    if (s === "REJECTED") return "danger";
    return "info";
  };

  return (
    <div className="dashboard_page">

      {/* HEADER */}
      <div className="page_header">
        <h2>{t("resorder_details")}</h2>

        <button className="btn_add_item_v2" onClick={onBack}>
          <i className="fa fa-arrow-left me-2"></i>{t("resback")}
        </button>
      </div>

      {/* ORDER SUMMARY */}
      {/* <div className="card order_summary">
        <div className="summary_left">
          <p>
            <b>{t("resorder_id")}:</b>{" "}
            <span dir="ltr" style={{ unicodeBidi: "isolate" }}>
              {formatOrderId(header.order_id)}
            </span>
          </p>
          <p><b>{t("resorder_date")}:</b>{" "}{formatDateTime(header.order_date)}</p>
          <p><b>{t("ressupplier")}:</b> {i18n.language === "ar"
            ? header.company_name_arabic || header.company_name_english
            : header.company_name_english}</p>
          <span className={`status_badge ${statusClass(header.status)}`}>
            {statusLabel(header.status)}
          </span>
        </div>

        <div className="summary_right">
          <span>{t("restotal_amount")}</span>
          <h3>{formatCurrency(header.total_amount)}</h3>
        </div>
      </div> */}



      <div className="card order_summary modern_order_summary">

        {/* LEFT ICON */}
        <div className="order_summary_icon">
          <i className="fas fa-clipboard-list"></i>
        </div>

        {/* CENTER DETAILS */}
        <div className="order_summary_details">

          <div className="summary_item">
            <i className="far fa-file-alt"></i>
            <div>
              <span>{t("resorder_id")}</span>
              <h6>{formatOrderId(header.order_id)}</h6>
            </div>
          </div>

          <div className="summary_item">
            <i className="far fa-calendar-alt"></i>
            <div>
              <span>{t("resorder_date")}</span>
              <h6>{formatDateTime(header.order_date)}</h6>
            </div>
          </div>

          <div className="summary_item">
            <i className="fas fa-store"></i>
            <div>
              <span>{t("ressupplier")}</span>
              <h6>
                {i18n.language === "ar"
                  ? header.company_name_arabic || header.company_name_english
                  : header.company_name_english}
              </h6>
            </div>
          </div>

          <div className="summary_item">
            <i className="far fa-user"></i>
            <div>
              <span>Placed By</span>
              <h6>{localStorage.getItem("username")}</h6>
            </div>
          </div>

        </div>

        {/* DIVIDER */}
        <div className="summary_divider"></div>

        {/* RIGHT AMOUNT */}
        <div className="order_summary_amount">

          <p>{t("restotal_amount")}</p>

          <div className="amount_card">
            <i className="fas fa-coins"></i>
            <h3>{formatCurrency(header.total_amount)}</h3>
          </div>

        </div>

      </div>

      {/* INFO GRID */}
      <div className="row mt-4">

        {/* RESTAURANT DETAILS */}
        <div className="col-md-6">
          <div className="card">
            <div class="grn-info-item detail-row">
              <div class="grn-info-icon supplier">
                <i class="fas fa-store-alt"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">{t("resrestaurant_details")}
                </div>
              </div>
            </div>
            <div className="summary_item detail-row">
              <i class="fa fa-user" aria-hidden="true"></i>
              <div>
                <p><b>{t("resname")}:</b>{" "}
                  {i18n.language === "ar"
                    ? header.restaurant_name_arabic || header.restaurant_name_english
                    : header.restaurant_name_english}</p>
              </div>
            </div>

            <div className="summary_item detail-row">
              <i class="fa fa-address-book" aria-hidden="true"></i>
              <div>
                <p><b>{t("rescontact")}:</b> {header.restaurant_contact_name}</p>
              </div>
            </div>

            <div className="summary_item detail-row">
              <i class="fa fa-mobile fa-mobile-dot" aria-hidden="true"></i>
              <div>
                <p>
                  <b>{t("resmobile")}:</b> {header.restaurant_contact_mobile}
                </p>
              </div>
            </div>


            <div className="summary_item detail-row">
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <div>
                <p><b>{t("resemail")}:</b> {header.restaurant_contact_email}</p>
              </div>
            </div>

            <div className="summary_item">
              <i class="fa fa-map-marker fa-location-dot"></i>
              <div>
                <p><b>{t("resaddress")}:</b><br />
                  {header.restaurant_street}, {header.restaurant_building}<br />
                  {t("resshop_no")}: {header.restaurant_shop_no}<br />
                  {t("reszone")}: {header.restaurant_zone}<br />
                  {header.restaurant_city}, {header.restaurant_country}</p>
              </div>
            </div>
          </div>
        </div>




        {/* SUPPLIER DETAILS */}
               <div className="col-md-6">
          <div className="card">
            <div class="grn-info-item detail-row">
              <div class="grn-info-icon user">
                <i class="fas fa-building"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">
						{t("ressupplier_details")}
                </div>
              </div>
            </div>
            <div className="summary_item detail-row">
              <i class="fa fa-user" aria-hidden="true"></i>
              <div>
                <p>
              <b>{t("resname")}:</b>{" "}
              {i18n.language === "ar"
                ? header.company_name_arabic || header.company_name_english
                : header.company_name_english}
            </p>
              </div>
            </div>

            <div className="summary_item detail-row">
              <i class="fa fa-address-book" aria-hidden="true"></i>
              <div>
                <p><b>{t("rescontact")}:</b>  {header.supplier_contact}</p>
              </div>
            </div>

            <div className="summary_item detail-row">
              <i class="fa fa-mobile fa-mobile-dot" aria-hidden="true"></i>
              <div>
                <p>
                  <b>{t("resmobile")}:</b> {header.supplier_mobile}
                </p>
              </div>
            </div>


            <div className="summary_item detail-row">
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <div>
                <p><b>{t("resemail")}:</b> {header.supplier_email}</p>
              </div>
            </div>

            <div className="summary_item">
              <i class="fa fa-map-marker fa-location-dot"></i>
              <div>
               <p className="mt-2">
              <b>{t("resaddress")}:</b><br />
              {header.supplier_address || header.supplier_street}<br />
              {t("reszone")}: {header.supplier_zone}<br />
              {header.supplier_country}
            </p>
              </div>
            </div>
          </div>
        </div>






      </div>


      {/* DELIVERY DETAILS */}
      {delivery && header.status === "OUT_FOR_DELIVERY" && (
        <div className="card mt-4">
          <h5 className="card_title">🚚 {t("resdelivery_details")}</h5>

          <p><b>{t("resdelivery_type")}:</b> {delivery.delivery_type}</p>

          {delivery.delivery_type === "OWN" && (
            <>
              <p><b>{t("resdriver")}:</b> {delivery.driver_name}</p>
              <p><b>{t("resdriver_mobile")}:</b> {delivery.driver_mobile}</p>

              <p><b>{t("resvehicle_type")}:</b> {delivery.vehicle_type || "-"}</p>
              <p><b>{t("resvehicle_number")}:</b> {delivery.vehicle_number || "-"}</p>
            </>
          )}

          {delivery.delivery_type === "PARTNER" && (
            <>
              <p><b>{t("respartner")}:</b> {delivery.partner_name}</p>
            </>
          )}

          <p>
            <b>{t("resestimated_arrival")}:</b>{" "}
            {delivery.estimated_delivery_time
              ? formatDateTime(delivery.estimated_delivery_time)
              : "-"}
          </p>
        </div>
      )}


      {delivery && header.status === "DELIVERED" && (
        <div className="card mt-4 border-success">
          <h5 className="card_title">✅ {t("resdelivery_completed")}</h5>

          {/* <p>
            <b>Delivered To:</b>{" "}
            {delivery.received_by || "Not specified"}
          </p>

          <p>
            <b>Delivered At:</b>{" "}
            {delivery.delivered_at
              ? new Date(delivery.delivered_at).toLocaleString()
              : "-"}
          </p> */}

          <hr />

          <p><b>{t("resdriver")}:</b> {delivery.driver_name}</p>
          <p><b>{t("resdriver_mobile")}:</b> {delivery.driver_mobile}</p>

          <p>
            <b>{t("resvehicle")}:</b>{" "}
            {delivery.vehicle_type || "-"} {delivery.vehicle_number || ""}
          </p>
        </div>
      )}


      {recurring && (
        <div className="card mt-3">
          <h5 className="card_title">{t("resrecurring_schedule")}</h5>

          <p><b>{t("resfrequency")}:</b> {recurring.frequency}</p>

          {recurring.weekdays?.length > 0 && (
            <p><b>{t("resdays")}:</b> {recurring.weekdays.join(", ")}</p>
          )}

          <p><b>{t("resstart_date")}:</b> {formatDateTime(recurring.start_date)}</p>

          {recurring.end_date && (
            <p><b>{t("resend_date")}:</b> {formatDateTime(recurring.end_date)}</p>
          )}

          <p><b>{t("resnext_run")}:</b> {formatDateTime(recurring.next_run_date)}</p>

          <p><b>{t("resstatus")}:</b> {recurring.status}</p>
        </div>
      )}



      {/* ITEMS */}
      <div className="card mt-4">
          <div class="grn-info-item detail-row">
              <div class="grn-info-icon date">
                <i class="fas fa-shopping-basket"></i>
              </div>
              <div class="grn-info-content">
                <div class="grn-info-value">
						{t("resorder_items")}
                </div>
              </div>
            </div>
      
        <table className="table order_table">
          <thead>
            <tr>
              <th>{t("resitem")}</th>
              <th>{t("resqty")}</th>
              <th className="text-end">{t("resprice")}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((i, idx) => (
              <tr  key={idx}>
                <td >
                  {i18n.language === "ar"
                    ? i.product_name_arabic || i.product_name_english
                    : i.product_name_english}
                </td>
                <td>{i.quantity}</td>
                <td className="text-end" dir="ltr">
                  {formatCurrency(i.total_amount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


      {/* ✅ REVIEW MODAL POPUP */}
      {showReviewModal && (
        <ReviewModal
          order={{
            order_id: header.order_id,
            supplier_name: header.supplier_name,
            total_amount: header.total_amount,
          }}
          onClose={() => setShowReviewModal(false)}
        />
      )}

      {/* ACTION BAR */}
      <div className="cta_bar">
        {header.status !== "DELIVERED" &&
          header.status !== "REJECTED" &&
          header.status !== "CANCELLED" && (
            <button
              className="view_btn"
              onClick={() => onTrack(orderId)}
            >
              <i className="fa fa-location-arrow me-2"></i>
              {t("restrack_order")}
            </button>
          )}

        {header.status === "DELIVERED" && (
          <>
            {/* ✅ REVIEW BUTTON */}
            <button
              className="btn btn-outline-success btn-lg"
              onClick={() => setShowReviewModal(true)}
            >
              {t("ressubmit_review")}
            </button>
            <button
              className="btn btn-outline-danger btn-lg"
              onClick={() =>
                navigate(`/restaurantdashboard/issues/${header.order_id}`)
              }
            >
              {t("resreport_issue")}
            </button>

            <button
              className="btn btn-outline-secondary btn-lg"
              onClick={() =>
                navigate("/restaurantdashboard/invoices", {
                  state: { orderId: header.order_id }
                })
              }
            >
              {t("resview_invoice")}
            </button>


            <button
              className="btn btn-outline-primary btn-lg"
              onClick={() =>
                navigate(`/restaurantdashboard/grn/${header.order_id}`)
              }
            >
              {t("rescreate_grn")}
            </button>

          </>
        )}
      </div>
    </div>
  );
};

export default OrderDetails;